export var ACTION_PENDING = 'pending';
export var ACTION_RESOLVING = 'resolving';
export var ACTION_RESOLVED = 'resolved';
export var ACTION_ERROR = 'errored';
export var ANALYTICS_RESOLVING = 'resolving';
export var ANALYTICS_ERROR = 'errored';
export var ANALYTICS_FALLBACK = 'fallback';
export var MAX_LOADING_DELAY = 1200;
export var MAX_RELOAD_DELAY = 15 * 1000;
export var ERROR_MESSAGE_OAUTH = 'Provider.authFlow is not set to OAuth2.';
export var ERROR_MESSAGE_FATAL = 'Fatal error resolving URL';
//# sourceMappingURL=constants.js.map